import { SearchListRequestPayload } from '../../shared/search-filter-pagination/search-bar/search-bar.types';

export function buildSearchQueryString(payload?: Partial<SearchListRequestPayload>): string {
  const params = buildSearchQueryParams(payload);
  const queryString = params.toString();

  return queryString ? `?${queryString}` : '';
}

export function buildSearchQueryParams(payload?: Partial<SearchListRequestPayload>): URLSearchParams {
  const params = new URLSearchParams();

  const query = `${payload?.query ?? ''}`.trim();

  if (query) {
    params.set('query', query);
  }

  const searchColumns = payload?.searchColumns ?? [];

  if (Array.isArray(searchColumns) && searchColumns.length > 0) {
    params.set('searchColumns', searchColumns.join(','));
  }

  const filters = payload?.filters ?? [];

  if (Array.isArray(filters) && filters.length > 0) {
    params.set('filters', JSON.stringify(filters));
  }

  params.set('page', String(payload?.page ?? 1));
  params.set('perPage', String(payload?.perPage ?? 25));
  // Owner-record endpoints use `limit`, while search-filter endpoints use
  // `perPage`. Send the same page size under both accepted contracts so a
  // shared list component cannot silently fall back to a different size.
  params.set('limit', String(payload?.perPage ?? 25));

  if (payload?.sort?.column) {
    params.set('sortColumn', payload.sort.column);
    params.set('sortDirection', payload.sort.direction ?? 'desc');
  }

  return params;
}
